import React, {useContext, useState} from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import {DataContext} from "../Content/Data";
import {DragDropContainer} from 'react-drag-drop-container';
import DropZone from "react-drop-zone";
import "../Music/Music2.css";
import "./maps.css"

export const Maps = () => {
    const [data, setData] = useContext(DataContext);
    const [active, setActive] = useState(false)

    const onActive = () => setActive(true);
    const offActive = () => setActive(false);

    console.log('map',active)

    const items =  data.Maps.map((map)=> {
            return (
                <div key={map.id}>
                    <DragDropContainer
                        class_Name={`maska`}
                        dragData={map}

                        onDragStart={onActive}
                        onDragEnd={offActive}
                        onClick={offActive}
                    >
                        <img src={map.src} className="yours-custom-class" alt={map.name}/>
                        <p>{map.name} </p>
                    </DragDropContainer>
                </div>
            )
        });
    items.push(<div key={-1} className={'ddcontainersource'}>
        <DropZone accept=".jpg, .jpeg, .png, .gif, .svg" onDrop={(file) =>{
        const newEl = {
            name: file.name,
            src: URL.createObjectURL(file),
            id: `drop${Math.random()}`
        };
        setData({...data, Maps: [newEl, ...data.Maps] });
    } }>
        {({over}) =>over?<div className='DropZone'>Upuść tutaj</div>:<p className='button'>Dodaj<br /> Nowy</p>}
    </DropZone>
    </div>)

    return (
        <div id={`Maps`}
             style={{width: '210px'}}
             className={active?'active':''}
             onClick={offActive}
        >
        <AliceCarousel touchTrackingEnabled={true}
                       items={items}
                       controlsStrategy='responsive'
                       autoPlayInterval = { 2000 }
                       // autoPlay = { true }
                       fadeOutAnimation = { true }

                       stagePaddin={{
                           paddingLeft : 0 ,
                           paddingRight : 0
                       }}
        />
        </div>
    );
}